
import { defineComponent, ref, onBeforeMount, onMounted, computed } from "vue";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { MutationNames, useStore } from "@/store";
import {
  resetPassword,
  getStudentInfo,
  checkPcExamAuthorization,
} from "@/services";
import useLogin from "@/hooks/useLogin";
import { platform, platform1 } from "@/services/platform";
import { LoginType } from "@/types";
import useJsBridge from "@/hooks/useJsBridge";
import _ from "lodash";
import useUpLoadResource from "@/hooks/useUpLoadResource";
import { uploadData } from "@/services";

export default defineComponent({
  setup() {
    console.time("home页面加载时间");
    const store = useStore();
    const { login } = useLogin();
    const { destoryOssResource } = useUpLoadResource();

    let placeholderOldPassword = ref("请输入密码");
    let placeholderNewPassword = ref("请输入新密码");
    let placeholderAgainNewPassword = ref("请再次输入密码");
    let password = ref("");
    let newPassword = ref("");
    let againNewPassword = ref("");
    let schoolIdToAuthorize = ref(0);
    let authResultType = ref(0);
    let authResultMessage = ref("");
    let isAuthorized = ref(false);
    let authLoading = ref(true);
    const loginType = computed(() => store.state.loginType);
    const schoolName = ref(store.state.schoolName);
    const name = ref(store.state.name);
    const grade = ref(store.state.grade);
    const classNumber = ref(store.state.classNumber);
    let displayPop = ref(false);
    let displayPassWord = ref(false);
    const router = useRouter();
    const gotoLogin = () => {
      // destoryOssResource();
      router.push({
        path: "/login",
      });
    };
    let isAndroid = ref(true);

    onBeforeRouteLeave((to, from) => {
      // if (to.name === "FreePractice") {
      //   router.options.routes.map((item: any) => {
      //     if (item.name === "FreePractice") {
      //       console.log(12123, item);
      //       item.meta = {
      //         title: "FreePractice",
      //         keepAlive: true,
      //       };
      //     }
      //   });
      // }
    });

    const blurSearchFor = (key: string) => {
      console.log("ssss3", key);
      if (key === "oldPassword") {
        placeholderOldPassword.value = "请输入密码";
      }
      if (key === "newPassword") {
        placeholderNewPassword.value = "请输入新密码";
      }
      if (key === "againNewPassword") {
        placeholderAgainNewPassword.value = "请再次输入密码";
      }
    };
    const focusSearchFor = (key: string) => {
      console.log("ssss", key);
      if (key === "oldPassword") {
        placeholderOldPassword.value = "";
      }
      if (key === "newPassword") {
        placeholderNewPassword.value = "";
      }
      if (key === "againNewPassword") {
        placeholderAgainNewPassword.value = "";
      }
    };
    const gotoExam = () => {
      if (
        loginType.value === LoginType.Account ||
        loginType.value === LoginType.Token
      ) {
        router.push({
          path: "/examPaperList",
        });
      } else {
        ElMessage({
          offset: 100,
          message: "请使用账号登录！",
          center: true,
        });
      }
    };
    const gotoMockExam = () => {
      console.time("模拟考列表加载时间");
      router.push({
        path: "/mockExamPaperList",
      });
    };
    const gotoFreePractice = () => {
      // ElMessage({
      //   offset: 100,
      //   message: "开发中,敬请期待......",
      //   center: true,
      // });
      console.time("自由练习加载时间");
      router.push({
        path: "/freePractice",
      });
    };
    // 返回安卓
    const gotoAndroid = () => {
      // eslint-disable-next-line no-undef
      (platform as AndroidPlatformInterface).exitWebView();
    };
    const btnReset = () => {
      // 关闭pop
      displayPop.value = !displayPop.value;
      // 打开重制密码
      displayPassWord.value = !displayPassWord.value;
    };
    const btnChangePassword = () => {
      const showMessage = (message: any) => {
        ElMessage({
          type: "warning",
          offset: 100,
          message,
          center: true,
        });
      };
      if (!password.value) {
        showMessage("请填写原始密码");
        return;
      }
      if (!newPassword.value) {
        showMessage("请填写新密码");
        return;
      }
      if (newPassword.value === password.value) {
        showMessage("新密码不能跟原始密码一样");
        return;
      }
      if (!againNewPassword.value) {
        showMessage("请再次确认新密码");
        return;
      }
      if (newPassword.value !== againNewPassword.value) {
        showMessage("2次密码不一致");
        return;
      }
      if (againNewPassword.value.length < 6) {
        showMessage("密码长度至少要6位");
        return;
      }
      resetPassword({
        new_password: againNewPassword.value,
        original_password: password.value,
      }).then(async () => {
        await login({
          account: store.state.account,
          password: againNewPassword.value,
        });
        displayPassWord.value = false;
        password.value = "";
        newPassword.value = "";
        againNewPassword.value = "";
      });
    };
    const btnCancel = () => {
      displayPassWord.value = !displayPassWord.value;
    };
    const btnAccountManage = () => {
      displayPop.value = !displayPop.value;
    };
    const goToDeviceCheck = () => {
      router.push({
        path: "/deviceCheck",
      });
    };
    const closeApp = _.throttle(
      async () => {
        ElMessageBox.confirm(
          `<div style="height: 100px; line-height:100px; font-size:24px">确定要关闭软件吗？</div>`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            center: true,
            showClose: false,
            dangerouslyUseHTMLString: true,
          }
        )
          .then(async () => {
            console.log(`通知关闭软件`);
            await platform.closeApp();
          })
          .catch(() => {
            console.log("取消");
          });
      },
      500,
      { leading: true }
    );
    // 信息上报
    const reportData = (schoolId: any) => {
      let mac = store.state.MAC.toUpperCase().replace(/:/g, "");
      if (mac === "0:0:0:0") {
        mac = mac + "-" + schoolId;
      }
      uploadData({
        chip_id: mac,
        school_id: schoolId,
        mac: mac,
        hardware_model: store.state.hardwareModel,
        software: "pc_exam",
        software_version: store.state.version,
        firmware: "windows",
        use_type: "12",
        screen_orientation: "0",
      }).then((data: any) => {
        console.log("success", data);
      });
    };
    onBeforeMount(async () => {
      const device = navigator.userAgent;
      isAndroid.value =
        device.indexOf("Android") > -1 || device.indexOf("Adr") > -1;
      console.log("loginType", loginType.value);
      console.log("schoolName1", store.state.examInfo);
      console.log("jsbirdge有没有", window.WebViewJavascriptBridge, window);

      // android 直接访问 home 页面
      console.time("时间评估: 获取token");
      platform.registerHandles();
      if (document.readyState == "complete") {
        console.log("document.readyState is complete");
        await platform.ready();
      } else {
        console.log(`document.readyState is ${document.readyState}`);
        document.onreadystatechange = async function (e: Event) {
          console.log(`document.readyState change is ${document.readyState}`);
          if (document.readyState == "complete") {
            await platform.ready();
          }
        };
      }
      // 获取mac
      const mac = await platform.getMac();
      console.log("h5MAc", mac);
      if (mac) {
        store.commit(MutationNames.CHANGE_MAC, mac);
      }
      console.timeEnd("home页面加载时间");
      // 获取学生信息中的schoolId
      if (isAndroid.value) {
        authLoading.value = false;
      }
      if (!isAndroid.value) {
        await getStudentInfo().then((res) => {
          schoolIdToAuthorize.value = res.school_id;
        });
        console.log("我拿到的学校Id是:", schoolIdToAuthorize.value);
        // 验证授权状态的接口
        await checkPcExamAuthorization({
          school_id: schoolIdToAuthorize.value,
          chip_id: store.state.MAC.toUpperCase().replace(/:/g, ""),
        }).then((res) => {
          authResultType.value = res.auth_result_type;
          authResultMessage.value = res.message;
          console.log("我是授权接口的返回值啊啊啊啊啊：", res);
          store.commit(MutationNames.CHANGE_AUTHORIZATION, res.enable);
          if (res.enable == true) {
            authLoading.value = false;
            isAuthorized.value = false;
            console.log("这里应该没有遮罩层");
            // 授权成功后数据上报
            reportData(schoolIdToAuthorize.value);
          } else {
            authLoading.value = false;
            isAuthorized.value = true;
            console.log("这里应该要有遮罩层");
          }
        });
      }
    });
    onMounted(async () => {
      console.log("schoolName2", store.state.schoolName);
      // 获取mac
      const mac = await platform.getMac();
      console.log("h5MAc", mac);
      if (mac) {
        store.commit(MutationNames.CHANGE_MAC, mac);
      }
      console.timeEnd("home页面加载时间");
    });
    return {
      placeholderOldPassword,
      placeholderNewPassword,
      placeholderAgainNewPassword,
      password,
      newPassword,
      againNewPassword,
      LoginType,
      loginType,
      schoolName,
      grade,
      classNumber,
      name,
      displayPop,
      displayPassWord,
      schoolIdToAuthorize,
      authResultType,
      authResultMessage,
      isAuthorized,
      authLoading,
      gotoLogin,
      btnAccountManage,
      btnCancel,
      btnChangePassword,
      btnReset,
      gotoExam,
      gotoMockExam,
      gotoFreePractice,
      goToDeviceCheck,
      gotoAndroid,
      blurSearchFor,
      focusSearchFor,
      reportData,
      closeApp,
      isAndroid,
      store,
    };
  },
});
